import baseConfig from '@/../config/themes';
import acronisSelfServiceLogo from '@/assets/images/acronis/acronis-logo-ss.svg';
import acronisSelfServiceLoginLogo from '@/assets/images/acronis/acronis-login-logo-ss.svg';
import acronisSelfServiceFavicon from '@/assets/images/acronis/favicon.png';

import virtuozzoLogo from '@/assets/images/virtuozzo/virtuozzo-logo-ss.svg';
import virtuozzoLoginLogo from '@/assets/images/virtuozzo/virtuozzo-login-logo-ss.svg';
import virtuozzoFavicon from '@/assets/images/virtuozzo/favicon.ico';
import schemes from '@uikit/ui-syntax/dist/js/colors';

export default {
  acronis: {
    ...baseConfig.acronis,
    logo: acronisSelfServiceLogo,
    loginLogo: acronisSelfServiceLoginLogo,
    logoIcon: 'i-a-logo--32',
    favicon: acronisSelfServiceFavicon,
    docsLink: 'https://www.acronis.com/support/documentation/',
    supportLink: 'https://www.acronis.com/support',
    cssVariables: schemes.DefaultColorScheme
  },
  virtuozzo: {
    ...baseConfig.virtuozzo,
    logo: virtuozzoLogo,
    loginLogo: virtuozzoLoginLogo,
    logoIcon: 'i-v-logo--32',
    favicon: virtuozzoFavicon,
    docsLink: 'https://docs.virtuozzo.com/master/index.html',
    supportLink: 'https://support.virtuozzo.com',
    cssVariables: schemes.VirtuozzoColorScheme
  }
};
